export class KanexPro {
    constructor(socket, log) {
        this.socket = socket;
        this.firmwareVersion = '1.0.1';
        this.ipAddress = '192.168.0.172';
        this.power = false;
        this.videoOutputs = []; // Zero based index (index 0 returns the input routed to output 1, ...)
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /\^Version;/i,
                callback: (match) => {
                    this.socket.send(`V${this.firmwareVersion}`);
                },
            },
            {
                name: 'getRoute',
                regExp: /STATUS(\d+)/i,
                callback: (match) => {
                    const output = parseInt(match[1], 10);
                    const input = this.videoOutputs[output - 1];
                    this.socket.send(`AV:${input.padStart(2, '0')}->${match[1].padStart(3, '0')}`);
                },
            },
            {
                name: 'setRoute',
                regExp: /(\d+)B(\d+)/i,
                callback: (match) => {
                    const output = parseInt(match[2], 10);
                    const input = match[1];
                    this.videoOutputs[output - 1] = input;
                    this.socket.send(`AV:${input.padStart(2, '0')}->${match[2].padStart(3, '0')}`);
                },
            },
            {
                name: 'setRouteAll',
                regExp: /(\d+)ALL/i,
                callback: (match) => {
                    this.videoOutputs.forEach((videoInput, i) => {
                        this.videoOutputs[i] = match[1];
                    });
                    this.socket.send(`All Through.`);
                },
            },
            {
                name: 'powerSet',
                regExp: /PW(ON|OFF)\./i,
                callback: (match) => {
                    this.power = match[1].toUpperCase() === 'ON';
                    this.socket.send(`PW${this.power ? 'ON' : 'OFF'}`);
                },
            },
            // The documentation doesn't describe the power get feature. I'm assuming it's part of
            // the STATUS. status command.
            {
                name: 'Status.',
                regExp: /STATUS/i,
                callback: (match) => {
                    this.getStatusResponse().forEach(resp => this.socket.send(resp));
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`CMD Error!`);
                },
            },
        ];
        this.commandExtractor = {
            terminators: ['.'],
        };
        this.sendTerminator = '\r\n';
    }
    onConfigure(config) {
        var _a, _b;
        this.ipAddress = (_a = config.ipAddress) !== null && _a !== void 0 ? _a : this.ipAddress;
        const numOutputs = Object.keys((_b = config === null || config === void 0 ? void 0 : config.videoOutputs) !== null && _b !== void 0 ? _b : {}).length;
        this.videoOutputs = Array(numOutputs).fill('01');
    }
    getStatusResponse() {
        const response = [];
        response.push('GUI Or RS232 Query Status:');
        response.push(`KanexPro HDMMX3232`);
        response.push(`${this.firmwareVersion}`);
        response.push(`Power ${this.power ? 'ON' : 'OFF'}`);
        response.push('Front Panel UnLock');
        response.push(`GUI_IP:${this.ipAddress}!`);
        this.videoOutputs.forEach((videoInput, i) => {
            // Video and then audio routing (audio follows video in this emulator).
            response.push(`V:${videoInput.padStart(2, '0')}->${(i + 1).toString().padStart(3, '0')}`);
            response.push(`A:${videoInput.padStart(2, '0')}->${(i + 1).toString().padStart(3, '0')}`);
        });
        return response;
    }
}
KanexPro.emulatorType = 'socketEmulator';
KanexPro.key = '-Ng428QSpsqPT1VTEHV1';
